import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { DialogService } from 'primeng/dynamicdialog';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AppLayoutModule } from './layout/app.layout.module';
import { UserService } from './service/user.service';
import { AuthService } from './service/auth.service';
import { UtilsService } from './service/utils.service';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { GBJwtInterceptor } from './interceptor/http-rr-jwt.interceptor';
import { LoginG } from './guards/login.g';
import { RootG } from './guards/root.g';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { ThirdPartySharedM } from './third-party-shared.m';
import { ConfirmationService, MessageService } from 'primeng/api';
import { NotificationService } from './service/notification.service';
import { ServiceWorkerModule } from '@angular/service-worker';
import {AdminG} from "./guards/admin.g";

@NgModule({
    declarations: [AppComponent],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        AppLayoutModule,
        ThirdPartySharedM,
        ServiceWorkerModule.register('ngsw-worker.js', {
            enabled: !isDevMode(),
            // Register the ServiceWorker as soon as the application is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        })
    ],
    providers: [
        {
            provide: LocationStrategy,
            useClass: PathLocationStrategy,

        },
        {
            provide: APP_INITIALIZER,
            useFactory: setUserFromLocalStorage,
            deps: [AuthService],
            multi: true,
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: GBJwtInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: setAMUserFromLocalStorage,
            deps: [UserService],
            multi: true,
        },

        AuthService,
        UserService,
        UtilsService,
        MessageService,
        NotificationService,
        ConfirmationService,
        DialogService,
        LoginG,
        RootG,
        AdminG
    ],
    bootstrap: [AppComponent],
})
export class AppModule {
}

export function setUserFromLocalStorage(authCS: AuthService) {
    return () => { // return function which returns promise.
        return new Promise<void>(async (resolve) => {
            try {
                const localStorageUser = authCS.getUserFromLocalStorage(environment.crypto.passJWT);
                if (localStorageUser) {
                    authCS.gUser = localStorageUser;
                    authCS.token.accessToken = <any>authCS.gUser.accessToken;
                    authCS.token.refreshToken = <any>authCS.gUser.refreshToken;
                }
            } catch (e) {
                console.log(e);
            }
            resolve();
        });
    };
}

export function setAMUserFromLocalStorage(userS: UserService) {
    return () => { // return function which returns promise.
        return new Promise<void>(async (resolve) => {
            try {
                const localStorageUser = userS.getAMUserFromLocalStorage(environment.crypto.passJWT);
                if (localStorageUser) {
                    userS.amUser = localStorageUser;
                }
            } catch (e) {
                console.log(e);
            }
            resolve();
        });
    };
}
